import React from "react";
import { useParams } from "react-router-dom";
import { useGetThemeByIdQuery } from "../../redux/API/ThemeApi";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import { ImgUrl, themeImgUrl } from "../../constant";
import EnquiryForm from "../components/form/Enquiryform";

const ThemeDetail = () => {
  const { id } = useParams();
  const { data: themeData, isLoading, isError } = useGetThemeByIdQuery(id);

  if (isLoading) return <p>Loading...</p>;
  if (isError || !themeData?.theme) return <p>Error fetching theme details</p>;

  const { name, image, description, overview, itinerary, otherInfo } =
    themeData.theme;

  return (
    <>
      <Navbar />
      <div className="hero_banner">

        <div className="destination-detail h-100">
          <img
            src={`${ImgUrl}${themeImgUrl}${image}`}
            alt={name}
            className="w-100 h-100 object-fit-cover"
          />

        </div>

      </div>
      <div className="container mt-4">
        <div className="row">
          <div className="col-lg-9">
            {/* Overview Section */}
            {overview && (
              <div className="mb-2">
                <h4 className="fw-bold">Overview</h4>
                <div dangerouslySetInnerHTML={{ __html: overview }} />
              </div>
            )}

            {/* Itinerary Section */}
            {itinerary && (
              <div className="mb-2">
                <h4 className="fw-bold">Itinerary</h4>
                <div dangerouslySetInnerHTML={{ __html: itinerary }} />
              </div>
            )}

            {/* Other Info Section */}
            {otherInfo && (
              <div className="mb-2">
                <h4 className="fw-bold">Other Information</h4>
                <div dangerouslySetInnerHTML={{ __html: otherInfo }} />
              </div>
            )}
          </div>
          <div className="col-lg-3">
            <EnquiryForm 
             pid={themeData?.theme?._id}
            />

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ThemeDetail;
